module.exports = __webpack_public_path__ + "static/fonts/AlimamaFangYuanTiVF-Thin.3be809e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AlimamaFangYuanTiVF-Thin.ttf
// module id = zoWL
// module chunks = 45